module.exports = __webpack_public_path__ + "img/adaptations7.56c498ac.png";